import { render } from "./SDKPage.vue?vue&type=template&id=d9a1c32e&scoped=true"
import script from "./SDKPage.vue?vue&type=script&lang=js"
export * from "./SDKPage.vue?vue&type=script&lang=js"

import "./SDKPage.vue?vue&type=style&index=0&id=d9a1c32e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a1c32e"]])

export default __exports__